// import React from "react"

// import { Bar } from 'react-chartjs-2';

// export const options = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: 'bottom',
//     },
//     title: {
//       display: true,
//       text: 'Chart.js Bar Chart',
//     },
//   },
// };

// const BarChart = ({ data }) => {

//   return (
//     <React.Fragment>
//       <Bar options={options} data={data} />
//     </React.Fragment>
//   )
// }

// export default BarChart

// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/bar
import { ResponsiveBar } from "@nivo/bar"
import { BarItem } from "./BarItem"
import "./style.css"

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const customColors = ["#f15331", "#015eb4"]

function BarChart({ data /* see data tab */ }) {
  return (
      <ResponsiveBar
        // className={"custom-bar"}
        // style={{ color: "red" }}
        // border={"1px solid green"}
        data={data}
        keys={["USAGE", "DEMAND"]}
        indexBy="month"
        margin={{ top: 10, right: 50, bottom: 50, left: 60 }}
        padding={0.3}
        groupMode="grouped"
        colors={customColors}
        // borderRadius={6}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 0,
          tickRotation: 0,
          legend: "showing 2023",
          legendPosition: "middle",
          legendOffset: 25,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 0,
          tickRotation: 0,
          legend: "kWh",
          legendPosition: "start",
          legendOffset: -45,
        }}
        enableGridY={false}
        labelSkipWidth={15}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={e =>
          e.id + ": " + e.formattedValue + " in month: " + e.indexValue
        }
        barComponent={BarItem}
        borderRadius={6}
        markers={[
          {
            axis: "y",
            value: 0,
            lineStyle: {
              stroke: "black",
            },
            textStyle: {
              fill: "grey",
            },
          },
        ]}
      />
  )
}

export default BarChart
